import React from 'react';
import { ComboList } from '../components/combo';
export const ComboPage = ()=>{
    return <ComboList/>
}